/* eslint-disable react/jsx-indent */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable no-empty-pattern */
/* eslint-disable no-multi-assign */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-unused-vars */
/* eslint-disable object-curly-newline */
/* eslint-disable import/order */
import React, { useEffect, useMemo, useContext, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router'

import { AppMountPoints } from '@apps/AppMounts'
import MountPoint from '@engine/components/MountPoint'
import {
  getProvince,
  setLandingLogicLoader,
  APPLICATION_STATE,
  ApplicationContext,
  ModifyApplicationContext
} from '@apps/contexts/ApplicationContext'
import useSite from '@engine/hooks/useSite'
import {
  updatePages,
  updateProvinces,
  changeSelectedLanguage,
  changeSelectedProvince,
  recordAccountInfo,
  setQuoteInfo,
  recordQuoteId,
  recordUserInfo,
  recordQuoteByEmailInfo,
  updateBurningToastAlerts
} from '@apps/redux/features/CommonSlice'
import {
  defaultPlan,
  // ////// MASC-17185 old plan API code start ////////
  // loadLocalizedPlanItem,
  // ////// MASC-17185 old plan API code end ////////
  updatePlansState,
  PLANS_STATE
} from '@apps/redux/features/PlansSlice'
import { recordSimSelectionInfo } from '@apps/redux/features/SimSelectionSlice'
import { updateAccountSetupState } from '@apps/redux/features/AccountSetupSlice'
import { PHONE_NUMBER_STATE, updatePhoneNumberState } from '@apps/redux/features/PhoneNumberSlice'
import { PAYMENT_STATE, updatePaymentStates } from '@apps/redux/features/PayAndReviewSlice'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import DealerActivationPaths from '@sites/dealer/activation/DealerActivationPaths'
import cookie from 'react-cookies'
// ////// MASC-17185 old plan API code start ////////
// import { convertCentsToDollars } from '@apps/flows/activation/services/accountHelper'
// ////// MASC-17185 old plan API code end ////////
import Sites from '@sites/index'
import { getById, getBySlug } from '@apps/utils/contentful'
import { navigateToPath } from '@apps/utils/navigation'
import Brands from '@brands/index'
import CookieManagementSystem from '@apps/components/CookieManagementSystem'
import AlertBanner from '@/apps/components/AlertBanner'
import { LANGUAGES_CODE } from '@/apps/utils/constants'
import { recordPhoneNumberInfo } from '@/apps/redux/features/PhoneNumberSlice'
import useLocale from '@/_engine/hooks/useLocale'
import {
  normalizePlanByIdForLocale,
  convertPlanPromoBundlesToDollars,
  mergeLocalizedPlanCopy
} from '@apps/utils/planByIdNormalizer'
import ProxyOperations from './services/operations'
import envConfigPlatform from '@platformConfig/index'

const {
  retrieveAccountByEmail,
  retrieveQuoteByEmail,
  getAllPagesData,
  createQuote,
  getPlanById,
  // ////// MASC-17185 old plan API code start ////////
  // getPlanList,
  // getPrepaidPlans,
  // ////// MASC-17185 old plan API code end ////////
} = ProxyOperations(Brands.public)

const {
  getProvinces,
  fetchAlerts,
  getUseMockFlag,
  // MASC-17220: ECP email must be sent under the Koodo brand so the payload
  // carries provider: "koodo" and downstream email/routing uses Koodo branding.
  sendEcpEmail
} = ProxyOperations(Brands.koodo)

// ////// MASC-17185 old plan API code start ////////
// const normalizeFeatureList = (value) => {
  // if (Array.isArray(value)) {
    // return value.filter(Boolean)
  // }

  // if (typeof value === 'string' && value.trim()) {
    // return [value]
  // }

  // return []
// }

// const normalizePrepaidPlanForLocale = (plan = {}, locale = 'en') => {
  // const localizedPromo = plan?.promotions?.[locale]
  // const localizedInfoRaw = plan?.info?.[locale]
    // || (
      // plan?.info && typeof plan.info === 'object' && !Array.isArray(plan.info)
        // ? plan.info
        // : null
    // )
  // const localizedInfo = Array.isArray(localizedInfoRaw) ? localizedInfoRaw[0] : localizedInfoRaw
  // const normalizedFeatures = normalizeFeatureList(plan?.features?.[locale])
  // const normalizedIncludedPlanFeatures = normalizeFeatureList(plan?.includedPlanFeatures?.[locale])
  // const normalizedHighlightedFeatures = normalizeFeatureList(plan?.highlightedFeatures?.[locale])
  // const normalizedOffers = normalizeFeatureList(plan?.offers?.[locale])
  // const normalizedBundles = Array.isArray(localizedPromo?.bundles)
    // ? localizedPromo.bundles.map((bundle = {}) => ({
      // ...bundle,
      // // The API can return both `name` and `namefr`; prefer locale-specific text.
      // name: locale === 'fr'
        // ? (bundle?.namefr || bundle?.name || '')
        // : (bundle?.name || bundle?.namefr || '')
    // }))
    // : []

  // return {
    // id: `${plan?.id || plan?.key || ''}`,
    // guid: plan?.guid,
    // name: plan?.name?.[locale] || '',
    // subtitle: plan?.subtitle?.[locale] || '',
    // sluggedName: plan?.sluggedName,
    // description: plan?.description?.[locale] || plan?.dataDescription?.[locale] || '',
    // dataDescription: plan?.dataDescription?.[locale] || '',
    // planData: plan?.planData?.[locale] || '',
    // planExpiryDate: plan?.planExpiryDate?.[locale] || '',
    // info: localizedInfo
      // ? {
        // icon: localizedInfo?.icon || '',
        // link: localizedInfo?.link || '',
        // text: localizedInfo?.text || ''
      // }
      // : null,
    // infoText: localizedInfo?.text || '',
    // value: plan?.cost ?? plan?.originalPrice ?? 0,
    // originalPrice: plan?.originalPrice ?? null,
    // duration: plan?.numOfDays,
    // // Keep `features` strictly mapped to the API `features` field.
    // features: normalizedFeatures,
    // includedPlanFeatures: normalizedIncludedPlanFeatures,
    // highlightedFeatures: normalizedHighlightedFeatures,
    // offers: normalizedOffers,
    // recommended: Boolean(plan?.isRecommended),
    // network: plan?.network || '',
    // ltpSavings: plan?.extraOffer?.[locale] || plan?.planRibbonContent?.[locale] || '',
    // extraOffer: plan?.extraOffer?.[locale] || '',
    // planRibbonContent: plan?.planRibbonContent?.[locale] || '',
    // options: Array.isArray(plan?.options) ? plan.options : [],
    // promo: localizedPromo
      // ? {
        // id: localizedPromo?.id,
        // description: localizedPromo?.description,
        // bundles: normalizedBundles
      // }
      // : null
  // }
// }

// const normalizePrepaidPlansResponse = (plansResponse) => {
  // const prepaidData = plansResponse?.data
  // if (!prepaidData || !Array.isArray(prepaidData?.plans)) {
    // return null
  // }

  // const mapLocalePlans = (locale) => ([{
    // displayFeaturedPlan: prepaidData?.displayFeaturedPlan,
    // plans: prepaidData.plans.map((plan) => normalizePrepaidPlanForLocale(plan, locale))
  // }])

  // return {
    // en: mapLocalePlans('en'),
    // fr: mapLocalePlans('fr')
  // }
// }
// ////// MASC-17185 old plan API code end ////////

const ActivationRoutes = () => {
  const { lang, prov } = useLocale()
  const dispatch = useDispatch()
  const history = useHistory()
  const site = useSite()
  const location = useLocation()
  const path = location.pathname
  const {
    content: { pageContent, featureFlags, burningToasts },
    userType,
    user: { email: userEmail, referrerUrl, isLoggedIn, accountByEmailInfo },
    quote: { quoteByEmailInfo }
  } = useSelector((state) => state.common)

  const { plan, localizedPlanItem } = useSelector((state) => state.plansPage)
  const phoneNumberState = useSelector((state) => state.phoneNumberPage) || {}
  const { [PHONE_NUMBER_STATE.PROVINCE_ID]: selectedProvinceId } = phoneNumberState
  const paymentState = useSelector((state) => state.payAndReviewPage)
  const {
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo,
    [PAYMENT_STATE.PROMO.MULTI_PROMO_CODES]: multiPromoCodes
  } = paymentState

  // Local copy of the by-email quote, and the in-flight request that produced
  // it. Refs, not state: the previous version kept this in state and read it
  // back by abusing the setter as a getter, which cannot work — the updater
  // does not run synchronously, so the caller always saw the initial `{}`.
  // That was harmless only while VerifyPage pre-loaded the quote into redux
  // before the OTP step; it no longer does (see checkEmailEligibility), so this
  // cache now has to actually hold a value.
  //
  // Keyed by the address that produced it, as is the redux copy below via this
  // ref: a cache hit that cannot name its owner can be served to the wrong one.
  // Redux outlives this component and the ref outlives a landing run, so a
  // second journey started in the same tab would otherwise route on, and
  // repopulate redux from, the first address's plan and port-in data.
  const quoteByEmailCacheRef = useRef({ email: null, response: null })
  const quoteByEmailRequestRef = useRef({ email: null, promise: null })
  const hasConsumerFetchRun = useRef(false)
  const hasDealerFetchRun = useRef(false)
  // `initiateLandingPage` runs more than once per landing (its effect depends on
  // `userEmail` / `isLoggedIn`, which `getUserInfo` dispatches), so the by-id plan
  // lookup is de-duped per plan/province/language.
  const planByIdFetchRef = useRef('')
  const planByIdRequestRef = useRef(null)
  // Locale the copy on the plan currently in the store belongs to, so the
  // re-localization effect below can tell a real language switch from its own
  // dispatch. Seeded lazily: on the first run there is no plan to re-word.
  const planCopyLocaleRef = useRef(null)

  const appState = useContext(ApplicationContext)
  const setAppState = useContext(ModifyApplicationContext)

  const {
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.IDENTITY]: identity
  } = appState

  const { retrieveCookie } = brandServices

  const consumerActivationPaths = new ConsumerActivationPaths()
  const dealerActivationPaths = new DealerActivationPaths()

  const page = getById(pageContent, `haveSimPage`) || {}
  const simSelectionPageContent = page[lang] || {}
  const { shortTextFields } = simSelectionPageContent
  const textContent = useMemo(() => {
    if (!shortTextFields) return {}
    return {
      eSimCost: getBySlug(shortTextFields, 'eSimCost')?.value,
      pSimCost: getBySlug(shortTextFields, 'pSimCost')?.value
    }
  }, [shortTextFields, userType])

  const eSimPrice = parseFloat(textContent?.eSimCost) ?? 0
  const pSimPrice = parseFloat(textContent?.pSimCost) ?? 0

  const KEY_PLAN_ID = 'plan'
  const PLAN_NOT_SELECTED = 'PLAN_NOT_SELECTED'

  const isDealer = userType === Sites.dealer
  const pagePrefix = isDealer ? 'Dealer' : 'Consumer'
  const plansPageContent = getById(pageContent, `plansPage${pagePrefix}`) || {}
  const autoPromoText = getBySlug(plansPageContent[language]?.shortTextFields, 'autoPromoText')?.value

  // ////// MASC-17185 old plan API code start ////////
  // const retrievePlans = async (plansResponse) => {
    // try {
      // if (!plansResponse || typeof plansResponse !== 'object') {
        // console.warn('plansResponse is null, undefined, or not an object')
        // return
      // }
      // const normalizedPrepaidPlans = normalizePrepaidPlansResponse(plansResponse)
      // const sourcePlansResponse = normalizedPrepaidPlans || plansResponse
      // const updatedPlansResponse = {}
      // Object.keys(sourcePlansResponse).forEach((language) => {
        // updatedPlansResponse[language] = []
        // const languagePlans = sourcePlansResponse?.[language]

        // // Check if languagePlans is an array before using forEach
        // if (Array.isArray(languagePlans)) {
          // languagePlans.forEach((langPlans) => {
            // const { plans, displayFeaturedPlan } = langPlans
            // const updatedPlans = plans?.map((currPlan) => {
              // if (currPlan?.promo) {
                // const bundleArray = currPlan?.promo?.bundles?.map((bundle) => {
                  // const {
                    // id, name, fee: rawFee, bundleType, unitType, numberMrc
                  // } = bundle

                  // return {
                    // id,
                    // name,
                    // fee: convertCentsToDollars(rawFee),
                    // bundleType,
                    // unitType,
                    // numberMrc
                  // }
                // })
                // const promo = {
                  // id: currPlan?.promo?.id,
                  // description: currPlan?.promo?.description,
                  // bundles: bundleArray
                // }
                // const updatedPlan = { ...currPlan }
                // updatedPlan.promo = promo
                // return updatedPlan
              // }
              // return currPlan
            // })
            // updatedPlansResponse[language].push({ displayFeaturedPlan, plans: updatedPlans })
          // })
        // }
      // })
      // dispatch(loadLocalizedPlanItem(updatedPlansResponse))
      // return updatedPlansResponse
    // } catch (err) {
      // console.log('error while retrieving plans', err)
    // }
  // }
  // ////// MASC-17185 old plan API code end ////////

  const fetchData = async () => {
    try {
      const fetchAlertsSafely = async () => {
        try {
          return await fetchAlerts(site)
        } catch (error) {
          console.error('fetchAlerts API failed:', error)
          return null
        }
      }
      // ////// MASC-17185 old plan API code start ////////
      // const channelOrgId = site === Sites.dealer ? identity?.channelOrgCode : ''
      // const accountProfile = accountByEmailInfo?.data?.profile || {}
      // const subscriberPhoneNumber = accountProfile?.phoneNumber || ''
      // const subscriberId = accountProfile?.subscriberId || ''

      // // Always construct prepaidPlanRequest to call getPrepaidPlans with available parameters
      // const prepaidPlanRequest = {
        // phoneNumber: subscriberPhoneNumber,
        // subscriberNumber: subscriberId,
        // selectedProvince: prov?.toUpperCase() || '',
        // portal: site,
        // channelOrgID: channelOrgId,
        // useCatalogPromos: true
      // }
      // ////// MASC-17185 old plan API code end ////////

      const [
        provincesResult,
        // ////// MASC-17185 old plan API code start ////////
        // planListResult,
        // prepaidPlanResult,
        // ////// MASC-17185 old plan API code end ////////
        allPageDataResult,
        alertsData
      ] = await Promise.all([
        getProvinces(),
        // ////// MASC-17185 old plan API code start ////////
        // getPlanList('', site, false, channelOrgId),
        // getPrepaidPlans(prepaidPlanRequest),
        // ////// MASC-17185 old plan API code end ////////
        getAllPagesData(site),
        fetchAlertsSafely()
      ])

      const sortedProvinces = provincesResult?.sort((a, b) => a.label.en.localeCompare(b.label.en))
      dispatch(updateProvinces(sortedProvinces))
      dispatch(updateBurningToastAlerts(alertsData))
      setAppState({ ...appState, [APPLICATION_STATE.PROVINCES]: sortedProvinces })

      // ////// MASC-17185 old plan API code start ////////
      // // Prioritize getPrepaidPlans response for plan card display
      // const hasPrepaidPlans = !prepaidPlanResult?.error
        // && Array.isArray(prepaidPlanResult?.data?.plans)
        // && prepaidPlanResult.data.plans.length > 0
      // const plansToDisplay = hasPrepaidPlans ? prepaidPlanResult : planListResult
      // retrievePlans(plansToDisplay)
      // ////// MASC-17185 old plan API code end ////////

      // Use API data from Contentful
      dispatch(updatePages(allPageDataResult))
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }

  useEffect(() => {
    if (pageContent) {
      return
    }

    if (site === Sites.consumer && !hasConsumerFetchRun.current) {
      // Set the guard synchronously, before any branch/await, so that when the
      // effect re-runs (its `identity` dependency flips undefined -> data once
      // getParams resolves) it cannot re-enter and fire the landing APIs a
      // second time. Previously the non-production `initialize` path only set
      // this guard after `await getUseMockFlag(...)`, so the identity-driven
      // re-run slipped through and fetchData ran twice.
      hasConsumerFetchRun.current = true
      if (envConfigPlatform.processEnv !== 'production') {
        initialize(site)
      } else {
        fetchData()
      }
      return
    }

    if (site === Sites.dealer && identity && !hasDealerFetchRun.current) {
      hasDealerFetchRun.current = true
      if (envConfigPlatform.processEnv !== 'production') {
        initialize(site)
      } else {
        fetchData()
      }
    }
  }, [identity])

  const initialize = async (site) => {
    try {
      const response = await getUseMockFlag(site)
      const value = response?.useMockAPI ?? false

      cookie.save('mockkpredata', value, { path: '/' })
      fetchData()
    } catch (error) {
      console.error('Error retrieving Contentful useMockAPI flag:', error)
      // The fetch guard is set synchronously by the caller and is never reset,
      // so getUseMockFlag failing must not leave the landing page permanently
      // unloaded. Default to real APIs (no mock) and still fetch the page data.
      cookie.save('mockkpredata', false, { path: '/' })
      fetchData()
    }
  }

  useEffect(() => {
    if (!pageContent) {
      return
    }
    if (userType === Sites.consumer) {
      initiateLandingPage(consumerActivationPaths)
    } else if (userType === Sites.dealer) {
      initiateLandingPage(dealerActivationPaths)
    }
  }, [userEmail, pageContent, userType, isLoggedIn])

  useEffect(() => {
    dispatch(changeSelectedLanguage(lang))
    dispatch(changeSelectedProvince(prov.toUpperCase()))
  }, [lang, prov])

  const getRetrieveAccountByEmail = async (email, subScriStatus) => {
    let result
    let isAlreadyActivated = false
    let autheticateData

    try {
      if (email) {
        if (accountByEmailInfo?.data) {
          autheticateData = accountByEmailInfo?.data
        } else {
          const retrieveAccountByEmailResponse = await retrieveAccountByEmail(email)
          const { data, error: autheticateError } = retrieveAccountByEmailResponse
          autheticateData = data
          if (autheticateError) {
            // console.log('AutheticateError error:', autheticateError)
            return { result: null, isAlreadyActivated: false }
          }
        }

        const {
          roles,
          statusCode,
          profile: { subscriberStatus, ban }
        } = autheticateData
        result = autheticateData

        const kPreUcareAccess = roles.some((role) => role === 'KPRE_UCARE_ACCESS')

        if (kPreUcareAccess) {
          dispatch(recordAccountInfo(autheticateData))
          if (userType === Sites.consumer) {
            history.push(consumerActivationPaths.AlreadyActivated)
          } else {
            history.push(dealerActivationPaths.AlreadyActivated)
          }
          isAlreadyActivated = true
        }
      }
    } catch (err) {
      // eslint-disable-next-line
      console.log(err, 'error while retrieving account by email')
    }
    return { result, isAlreadyActivated }
  }

  const processQuoteData = async (quoteData, activationPaths) => {
    if (quoteData?.quoteId) {
      dispatch(setQuoteInfo(quoteData))

      const {
        fullName, provinceId, language, dynamicCode, SimInformation
      } = quoteData
      if (fullName) {
        const [firstName, lastName] = fullName.split(' ')
        dispatch(
          updateAccountSetupState({
            firstName,
            lastName,
            pin: dynamicCode,
            confirmPin: dynamicCode,
            language: language === LANGUAGES_CODE.EN ? 0 : 1
          })
        )
      }
      if (provinceId) {
        const { shortName } = getProvince(provinceId)
        dispatch(
          updatePhoneNumberState({
            [PHONE_NUMBER_STATE.PROVINCE_ID]: provinceId,
            [PHONE_NUMBER_STATE.PROVINCE_NAME]: shortName
          })
        )
      }

      if (
        userType === Sites.dealer &&
        (quoteData.currentState === 'Phone Number Selection' ||
          quoteData.currentState === 'Plan Selection' ||
          quoteData.currentState === 'Payment Information') &&
        SimInformation?.simType === 'ESIM' &&
        !SimInformation.eid
      ) {
        history.push(activationPaths.SimSelection)
      } else {
        await navigateToPath(
          quoteData.currentState,
          activationPaths,
          history,
          lang,
          prov,
          localizedPlanItem,
          quoteData?.pricePlanId
        )
      }
    }
  }

  const getRetrieveQuoteByEmail = async (email, activationPaths, retrieveAccountByEmailData) => {
    let response
    let isDeactivated = false

    try {
      // Serve from whichever cache is warm. The old guard here was
      // `quoteByEmailInfo?.data || userEmail === email`, and the second half
      // stood in for this local cache — but `userEmail === email` is always
      // true on the post-login landing run (recordUserInfo has just set it), so
      // with redux cold it took the no-fetch branch and yielded an empty
      // response. A returning user's in-progress quote then read as deactivated
      // and the landing logic created them a brand new one, losing their
      // progress. It only ever worked because VerifyPage had pre-populated
      // redux pre-OTP, which it no longer does.
      //
      // Only once the cache can be shown to belong to this address. The redux
      // copy carries no address of its own — the quote selection set has no
      // email on it — so the ref vouches for it. After a remount the ref is
      // empty and the quote is fetched again, which is the safe direction to
      // fall.
      const isCachedEmail = quoteByEmailCacheRef.current.email === email
      const cached = isCachedEmail
        && (quoteByEmailInfo?.data ? quoteByEmailInfo : quoteByEmailCacheRef.current.response)

      if (cached?.data) {
        response = cached
      } else {
        // Drop a hit that belonged to someone else before the fetch, so the
        // stale quote cannot be read back out of redux by anything downstream
        // while this one is in flight.
        if (!isCachedEmail && quoteByEmailInfo?.data) {
          dispatch(recordQuoteByEmailInfo({}))
        }

        // The landing effect re-runs on userEmail/isLoggedIn, so de-dupe by
        // reusing the in-flight promise for the same address rather than
        // skipping the fetch outright.
        //
        // Lifetime: deliberately not reset once it settles, so repeat landing
        // runs for the same address replay the resolved response instead of
        // re-fetching. That is what the `userEmail === email` guard used to do,
        // minus the empty-response bug. A changed address replaces it, and the
        // catch below clears it so a failure is retried. The window where this
        // could go stale — a quote created after the fetch — is not reachable,
        // since createQuote does not retrigger the landing effect.
        if (quoteByEmailRequestRef.current.email !== email || !quoteByEmailRequestRef.current.promise) {
          quoteByEmailRequestRef.current = { email, promise: retrieveQuoteByEmail({ email }) }
        }
        response = await quoteByEmailRequestRef.current.promise

        isDeactivated = (response?.data?.quoteState?.toUpperCase() !== 'IN_PROGRESS'
          && !retrieveAccountByEmailData?.profile?.accountGuid
          && !retrieveAccountByEmailData?.profile?.subscriberGuid)

        if (!isDeactivated) {
          dispatch(recordQuoteByEmailInfo(response))
          quoteByEmailCacheRef.current = { email, response }
        }
      }

      isDeactivated = (response?.data?.quoteState?.toUpperCase() !== 'IN_PROGRESS'
        && !retrieveAccountByEmailData?.profile?.accountGuid
        && !retrieveAccountByEmailData?.profile?.subscriberGuid)

      if (!isDeactivated) {
        await handlePlanSelection(
          response?.data?.pricePlanId,
          response?.data?.isPlanSelected,
          response?.data?.provinceId
        )
        processQuoteData(response.data, activationPaths)
        dispatch(setQuoteInfo(response.data))
      }
    } catch (err) {
      console.log(err, 'error while retrieving quote information')
      // Drop the memoised request so a transient failure is retried on the next
      // landing run instead of being replayed from the ref.
      quoteByEmailRequestRef.current = { email: null, promise: null }
      history.push(activationPaths.Splash)
    }
    return response
  }

  const setCreateQuote = async (input) => {
    const cameFromPlanSelection = referrerUrl?.includes('/activation/plans')
    let result
    try {
      result = await createQuote({
        customerId: input,
        pricePlanId: plan?.id,
        pricePlanGuid: plan?.guid,
        fullName: '',
        language: lang,
        isPlanSelected: cameFromPlanSelection
      })
      if (result?.data?.quoteId) {
        dispatch(recordQuoteId(result?.data))

        if (plan?.id) {
          cookie.save(KEY_PLAN_ID, plan?.id, { path: '/' })
        }

        const ecpPayload = {}
        ecpPayload.locale = lang
        ecpPayload.email = input
        sendEcpEmail(ecpPayload)
      }
    } catch (err) {
      // eslint-disable-next-line
      console.log(err, 'error while creating quote')
    }
    return result
  }

  const getUserInfo = async () => {
    const userInfo = {}
    const { userSessionId, userEmail, isLoggedIn } = ({} = (await retrieveCookie()) || {})
    userInfo.email = userEmail
    userInfo.isLoggedIn = isLoggedIn
    userInfo.selectedLanguage = language
    if (userSessionId && userInfo && userInfo?.email && isLoggedIn) {
      dispatch(recordUserInfo(userInfo))
    }

    return userInfo
  }

  const waitForUserInfo = async (delay = 1000) => {
    await new Promise((resolve) => setTimeout(resolve, delay))
    const userInfo = await getUserInfo()
    return userInfo
  }

  const initiateLandingPage = async (activationPaths) => {
    const subscriptionStatus = [
      'active',
      'suspended',
      'expired',
      'lost-stolen / fermé',
      'draft',
      'preactivate'
    ]
    const userInfo = await waitForUserInfo()

    if (userInfo.isLoggedIn) {
      setLandingLogicLoader(true)
    }

    if (!userInfo || !userInfo.email || !userInfo.isLoggedIn || !isLoggedIn) {
      if (userInfo.isLoggedIn) {
        setLandingLogicLoader(true)
      } else {
        setLandingLogicLoader(false)
        return
      }
    }

    const {
      result: retrieveAccountByEmailData,
      isAlreadyActivated
    } = await getRetrieveAccountByEmail(userInfo?.email, subscriptionStatus)
    if (retrieveAccountByEmailData && !isAlreadyActivated) {

      // ////// MASC-17185 old plan API code start ////////
      // const subscriberPhone = retrieveAccountByEmailData?.profile?.phoneNumber
      // const subscriberId = retrieveAccountByEmailData?.profile?.subscriberId

      // try {
        // const channelOrgId = site === Sites.dealer ? identity?.channelOrgCode : ''

        // const prepaidResult = await getPrepaidPlans({
          // phoneNumber: subscriberPhone || '',
          // subscriberNumber: subscriberId || '',
          // selectedProvince: prov?.toUpperCase() || '',
          // portal: site,
          // channelOrgID: channelOrgId,
          // useCatalogPromos: true
        // })

        // const hasPrepaidPlans = !prepaidResult?.error
          // && Array.isArray(prepaidResult?.data?.plans)
          // && prepaidResult.data.plans.length > 0

        // if (hasPrepaidPlans) {
          // retrievePlans(prepaidResult)
        // }
      // } catch (err) {
        // console.error('[initiateLandingPage] getPrepaidPlans failed:', err)
      // }
      // ////// MASC-17185 old plan API code end ////////

      const retrieveQuoteData = await getRetrieveQuoteByEmail(userInfo?.email, activationPaths, retrieveAccountByEmailData)
      const isDeactivated = retrieveQuoteData?.data?.quoteState?.toUpperCase() !== 'IN_PROGRESS'
        && !retrieveAccountByEmailData?.profile?.accountGuid
        && !retrieveAccountByEmailData?.profile?.subscriberGuid

      if (
        retrieveQuoteData?.data?.quoteState?.toUpperCase() !== 'IN_PROGRESS'
        && retrieveAccountByEmailData?.profile?.accountGuid
        && retrieveAccountByEmailData?.profile?.subscriberGuid
      ) {
        setLandingLogicLoader(false)
        history.push(activationPaths.ProcessFailure)
        return
      }

      if (
        (retrieveQuoteData?.data?.quoteId === null &&
          !subscriptionStatus.includes(retrieveAccountByEmailData?.subscriberStatus?.toLowerCase()))
        || isDeactivated
      ) {
        const createQuoteData = await setCreateQuote(userInfo?.email)
        if (createQuoteData?.data?.quoteId) {
          history.push(activationPaths.AccountSetup)
          setLandingLogicLoader(false)
        } else {
          setLandingLogicLoader(false)
          history.push(activationPaths.Splash)
        }
      }

      if (!isDeactivated) {
        dispatch(
          recordSimSelectionInfo({ ...retrieveQuoteData?.data?.SimInformation, eSimPrice, pSimPrice })
        )
        if (retrieveQuoteData?.data?.UserData && retrieveQuoteData?.data?.UserData?.portIn !== null) {
          dispatch(recordPhoneNumberInfo(retrieveQuoteData?.data?.UserData))
        }
      }

      setLandingLogicLoader(false)
    }
    setLandingLogicLoader(false)
  }

  const setSelectedPlan = (selectedPlan, allPlans, isPreSelected) => {
    dispatch(
      updatePlansState({
        [PLANS_STATE.PLAN]: selectedPlan,
        [PLANS_STATE.PRE_SELECTED_PLAN]: isPreSelected,
        [PLANS_STATE.SELECTED_PLAN_OPTION]: selectedPlan.duration,
        [PLANS_STATE.ALL_PLANS]: allPlans
      })
    )
    if (selectedPlan?.promo) {
      // Optional chaining, not `featureFlags &&`: an empty flags array would throw
      // on `featureFlags[0].enableMultiPromo`, and that throw is caught by
      // getRetrieveQuoteByEmail, which redirects to Splash.
      if (
        featureFlags?.[0]?.enableMultiPromo &&
        multiPromotionCodeInfo?.length === 0 &&
        multiPromoCodes?.length === 0
      ) {
        dispatch(
          updatePaymentStates({
            [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: [selectedPlan.promo],
            [PAYMENT_STATE.PROMO.MULTI_PROMO_CODES]: [autoPromoText]
          })
        )
      }
    }
  }

  const validPlanForProvince = (preSelectedPlan, provinceId) => {
    const { shortName = '' } = getProvince(provinceId)
    return preSelectedPlan?.province?.find((pr) => pr?.toUpperCase() === shortName.toUpperCase())
  }

  // Released on any failed lookup so a later landing run can retry; kept on
  // success so the duplicate run is served the same resolved plan.
  const clearPlanByIdGuards = () => {
    planByIdFetchRef.current = ''
    planByIdRequestRef.current = null
  }

  // Replaces the catalog scan the old getPlanList response used to serve. Since
  // MASC-17185 `localizedPlanItem` is only hydrated by IntroPage's deep-link
  // effect, so on any refresh landing away from /activation/plans/:planName there
  // is no catalog and the plan cannot be restored into the order summary.
  const fetchPlanById = (pricePlanId, provinceId) => {
    const { shortName = '' } = getProvince(provinceId) || {}
    const selectedProvince = `${shortName || prov || ''}`.toUpperCase()
    const fetchKey = `${pricePlanId}:${selectedProvince}:${lang}`

    // Share the in-flight promise with the duplicate run rather than resolving
    // `undefined` for it — that would fall through to the `isPlanSelected ===
    // false` branch below and reset the plan to `defaultPlan`.
    if (planByIdFetchRef.current === fetchKey && planByIdRequestRef.current) {
      return planByIdRequestRef.current
    }

    planByIdFetchRef.current = fetchKey
    planByIdRequestRef.current = (async () => {
      try {
        const planByIdResult = await getPlanById({
          planId: String(pricePlanId),
          phoneNumber: '',
          selectedProvince
        })

        // A failed lookup resolves rather than throwing — the backend turns both
        // transport errors and bad payloads into `generateError`, i.e. no `data`
        // — so clear the guards here too, not only in the catch.
        if (!planByIdResult?.data) {
          clearPlanByIdGuards()
          return undefined
        }

        return convertPlanPromoBundlesToDollars(
          normalizePlanByIdForLocale(planByIdResult.data, lang)
        )
      } catch (error) {
        clearPlanByIdGuards()
        console.error('[ActivationRoutes] getPlanById failed:', error)
        return undefined
      }
    })()

    return planByIdRequestRef.current
  }

  // The selected plan is stored as a single-locale snapshot: the plans MFE hands
  // `onSelect` only the copy for the language active at click time, and both
  // getPlanById paths normalize to one locale before dispatching. Switching
  // EN/FR afterwards swaps ApplicationContext and the URL but leaves that
  // snapshot alone, so the order summary went on rendering the plan name and
  // features in the language the plan was chosen in.
  //
  // Lives here rather than in OrderSummary because the plan is shared redux
  // state: one effect at the single flow-level mount re-words it for every
  // consumer (order summary, transaction summary) and cannot double-fetch the
  // way a per-page component would.
  useEffect(() => {
    const planId = plan?.id
    // No id means `defaultPlan`, the not-yet-selected placeholder — nothing to
    // re-word, but keep the ref in step so the plan the user goes on to select
    // (already in this locale) is not mistaken for a pending switch.
    if (!planId) {
      planCopyLocaleRef.current = lang
      return undefined
    }
    if (planCopyLocaleRef.current === lang) return undefined

    let cancelled = false

    const relocalizePlanCopy = async () => {
      // Catalog first when IntroPage's deep-link effect hydrated it: it already
      // holds every locale, so no network call is needed. Otherwise fall back to
      // getPlanById, which fetches per locale and de-dupes on language.
      const catalogPlans = localizedPlanItem?.[lang]?.find(Boolean)?.plans
      const localizedPlan = catalogPlans?.find(
        (catalogPlan) => String(catalogPlan?.id) === String(planId)
      ) || await fetchPlanById(planId, selectedProvinceId)

      if (cancelled || !localizedPlan) return

      // Only claim the store carries this locale once it actually does, so a
      // failed lookup retries on the next toggle instead of latching stale copy.
      planCopyLocaleRef.current = lang
      dispatch(updatePlansState({
        [PLANS_STATE.PLAN]: mergeLocalizedPlanCopy(plan, localizedPlan)
      }))
    }

    relocalizePlanCopy()

    return () => {
      cancelled = true
    }
    // `plan` itself is intentionally not a dependency: this effect dispatches a
    // new plan object, and re-running on that would loop.
  }, [lang, plan?.id, localizedPlanItem, selectedProvinceId])

  const handlePlanSelection = async (pricePlanId, isPlanSelected, provinceId) => {
    let currentPlan
    const langPlans = localizedPlanItem?.[lang]
    const plansObject = langPlans?.find(Boolean) || {}
    const { plans = [] } = plansObject
    const hasPricePlanId = pricePlanId && pricePlanId !== PLAN_NOT_SELECTED

    if (hasPricePlanId && plans.length > 0) {
      currentPlan = plans?.find((planData) => planData?.id === pricePlanId)
    }

    // Only when the catalog scan came up empty and the quote names a plan.
    if (!currentPlan && hasPricePlanId) {
      currentPlan = await fetchPlanById(pricePlanId, provinceId)
    }

    if (currentPlan) {
      setSelectedPlan(currentPlan, plans, !!isPlanSelected)
    } else if (isPlanSelected === false) {
      if (plan?.id && validPlanForProvince(plan, provinceId)) {
        setSelectedPlan(plan, plans, isPlanSelected)
      } else {
        setSelectedPlan(defaultPlan, plans, isPlanSelected)
      }
    } else {
      // Plan unresolved but the quote says it was pre-selected: persist the flag
      // on its own, otherwise the step tracker falls back to its `false` default
      // and renders 5 steps instead of 4.
      dispatch(updatePlansState({ [PLANS_STATE.PRE_SELECTED_PLAN]: !!isPlanSelected }))
    }
  }

  return (
    // ORIGINAL: bg-background (Koodo theme cream). Changed to bg-[#fafafa] per Figma (node 11309:61952).
    <div className="relative min-h-screen bg-[#fafafa] flex flex-col">
      {burningToasts?.length > 0 && (
        <div>
          <AlertBanner
            alert={burningToasts}
            lang={lang}
            currentProvince={prov}
            currentPage={path}
          />
        </div>
      )}
      <div className="flex-grow relative">
        <MountPoint name={AppMountPoints.activationMount} />
      </div>
      {/* Cookie Management System - Normal document flow */}
      <CookieManagementSystem />
    </div>
  )
}

export default ActivationRoutes
